import { getRecommendProductDrLogByCatalogProductId } from '@common/checkout-utils';
import { useUBL, useUBLContext } from '@common/log-manager';
import { useCheckoutUBL } from '@widgets/checkout-log-manager';
import { formatCategoryList } from '@widgets/web-save-product';
import { useCatalogProductIdParams, useGetPdpIntegratedData, usePdpBaseInfo, usePdpConfig } from '@domains/pdp-common';

const NAVIGATION = 'product_detail';

export function useSubButtonLog() {
  const sendUBL = useUBL();
  const sendCheckoutUBL = useCheckoutUBL();

  const params = useCatalogProductIdParams();
  const { product, shop } = usePdpBaseInfo(params);
  const { hasReviewPredictSummary } = useGetPdpIntegratedData({ catalog_product_id: params.catalog_product_id });
  const { isProductPreview, funnelType } = usePdpConfig();
  const { navigation } = useUBLContext();

  const reviewClickUBL = () => {
    sendUBL({
      category: 'click',
      navigation: 'product_detail',
      object_section: 'bottom_bar',
      object_type: 'button',
      object_id: 'review_all',
      data: {
        catalog_product_id: params.catalog_product_id,
        browsing_type: product.browsing_type,
        review_predict_summary: hasReviewPredictSummary,
      },
    });
  };

  const getWisthListAirbridge = () => {
    return {
      brandID: shop.id,
      brandName: shop.name,
      productID: product.id,
      productName: product.name,
      price: product.product_price,
      categoryID: formatCategoryList(product.managed_category_list, 'category_id'),
      categoryName: formatCategoryList(product.managed_category_list, 'value'),
    };
  };

  const likeProductUBL = (isLiked: boolean, data: { catalog_product_id: string }) => {
    if (isProductPreview) {
      const dr_log = getRecommendProductDrLogByCatalogProductId(data.catalog_product_id);
      sendCheckoutUBL({
        category: isLiked ? 'save_product' : 'remove_saved_product',
        navigation,
        object_section: 'bottom_bar',
        object_type: 'catalog',
        object_id: data.catalog_product_id,
        data: {
          funnel_info_type: funnelType,
          ...(dr_log && {
            server_log: {
              dr_log,
            },
          }),
        },
      });
    } else {
      sendUBL({
        category: isLiked ? 'save_product' : 'remove_saved_product',
        navigation: NAVIGATION,
        object_section: 'bottom_bar',
        object_id: data.catalog_product_id,
      });
    }
  };

  return {
    reviewClickUBL,
    likeProductUBL,
    getWisthListAirbridge,
  };
}
